import { render } from "./QueryByMention.vue?vue&type=template&id=700c70c6&ts=true"
import script from "./QueryByMention.vue?vue&type=script&lang=ts"
export * from "./QueryByMention.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__